export default {
  route: {
    '密码计算': 'Calculadora De Contraseñas',
    '公告': 'Anuncio',
    '公告详情': 'Detalles Del Anuncio',
    '在线考试': 'Examen En Linea',
    '考试记录': 'Registros De Examen',
    '证书信息': 'Información Certificada',
    '证书统计': 'Estadísticas Certificados',
    '公告管理': 'Gestión De Anuncios',
    '培训视频': 'Vídeo De Entrenamiento',
    '培训视频管理': 'Gestión Vídeos Formación',
    '视频标签管理': 'Gestión Etiquetas Vídeo',
    '设备信息': 'Dispositivo',
    '经销商信息': 'Distribuidor',
    '经销商-设备': 'Distribuidor-dispositivo',
    '经销商-设备关联': 'Distribuidor-dispositivo',
    '设备关联': 'De Dispositivos',
    '经销商-账号关联': 'Distribuidor-cuenta',
    '系统字典': 'Diccionario Del Sistema',
    '算号记录': 'Registros De Cálculo',
    '账户管理': 'Cuentas',
    '用户管理': 'Gestión Usuarios',
    '组织管理': 'Gestión Organizaciones',
    '角色管理': 'Gestión Roles',
    '功能管理': 'Gestión Funciones',
    '技术文档资料库': 'Documentación Técnica',
    '员工权限': 'Permisos Del Personal',
    '题库管理': 'Gestión Banco Preguntas',
    '单选题库管理': 'Radio Banco',
    '多选题库管理': 'Opción Multiple Banco',
    '判断题库管理': 'Juez Banco',
    '考试培训': 'Entrenamiento Examen',
    '系统管理': 'Gestión Sistema'
  },
  lang: {
    '认证经销商服务平台': 'Plataforma De Apoyo A Contratistas Autorizados',
    '用户名': 'Nombre De Usuario',
    '密码': 'Contraseña',
    '登录': 'Intro',
    '当前版本': 'Versión Actual',
    '请输入用户名': 'Introduzca su nombre de usuari',
    '请输入密码': 'Por favor escribe su contraseña',
    '您的密码强度太低，请尽快修改密码': 'El nivel de seguridad de tu contraseña es demasiado bajo, cámbiala lo antes posible',
    '修改密码': 'Cambiar La Contraseña',
    '修改头像': 'Modificar El Avatar',
    '原始密码': 'Contraseña Original',
    '新密码': 'Nueva Contraseña',
    '可选择': 'Opcional',
    '确认新密码': 'Confirmar nueva contraseña',
    '请输入原始密码': 'Introduzca la contraseña original',
    '两次输入密码不一致': 'Las contraseñas introducidas dos veces son inconsistentes',
    '请输入新密码': 'Por favor escribe la nueva contraseña',
    '请输入不少于6位的密码': 'Por favor escribe una contraseña de no menos de 6 dígitos',
    '修改成功,请重新登录!': 'La modificación se ha realizado correctamente, vuelva a iniciar sesión!',
    '修改失败!': 'No se ha podido modificar!',
    '请上传正确的图片格式（jpge/jpg/png/gif）': 'Please upload the correct picture format（jpge/jpg/png/gif）',
    '图片大小超过1M，请重新选择!': 'El tamaño de la imagen es superior a 1M, por favor selecciónela de nuevo!',
    '图片命名中包含特殊字符，请规正命名再上传!': 'La imagen contiene caracteres especiales, por favor, cámbiale el nombre y vuelve a subirla!',
    '请选择头像上传': 'Por favor, selecciona un avatar para subir',
    '更改头像成功!': 'Cambia el avatar correctamente!',
    '更改头像失败!': 'No se ha podido cambiar el avatar!',
    '取消': 'Cancelar',
    '确认': 'Confirmar',
    '操作': 'Operación',
    '编辑': 'Editar',
    '启用中': 'Activado',
    '禁用中': 'Desactivado',
    '编辑菜单': 'Editar Menús',
    '编辑功能': 'Editar Funciones',
    '添加功能': 'Agregar Función',
    '您已修改状态为 --> 禁用': 'Has modificado el estado a --> desactivado',
    '您已修改状态为 --> 启用': 'Has modificado el estado a --> activado',
    '添加成功': 'Añadido correctamente',
    '添加失败': 'No se ha podido agregar',
    '编辑成功': 'Editado con éxito',
    '编辑失败': 'Error al editar',
    '请选择': 'Por favor, seleccione',
    '状态': 'Estado',
    '作废': 'Cancelar',
    '功能': 'Función',
    '请输入功能名称': 'Introduce el nombre de la función',
    '功能名': 'Nombre De La Función',
    '请输入功能': 'Por favor escribe la descripción de la función',
    '功能url': 'Url De La Función',
    '请输入功能url': 'Por favor escribe la url de la función',
    '菜单/功能': 'Menus/Function',
    '菜单': 'Menus',
    '请输入菜单': 'Por favor escribe los menús',
    '菜单名': 'Nombre Del Menú',
    '请输入菜单名': 'Por favor escribe el nombre del menú',
    '是否必选': 'Es Necesario Elegir',
    '添加菜单': 'Agregar Menú',
    '父级菜单': 'Menú De Nivel Superior',
    '是': 'Y',
    '否': 'N',
    '启用': 'Activado',
    '禁用': 'Desactivado',
    '状态修改失败': 'Error al modificar el estado',
    '请选择功能': 'Seleccione la función',
    '查询': 'Consulta',
    '添加': 'Agregar',
    '组织': 'Organización',
    '父级组织': 'Organización De Nivel Superior',
    '请输入组织名称': 'Introduzca el nombre de la organización',
    '类型': 'Tipo',
    '地址': 'Dirección',
    '添加组织': 'Agregar Organización',
    '编辑组织': 'Editar Organización',
    '名称': 'Nombre',
    '该组织名称已存在': 'El nombre de la organización ya existe',
    '获取组织根节点列表失败': 'Error al obtener la lista de nodos raíz de la organización',
    '请选择组织': 'Por favor, seleccione una organización',
    '角色': 'Rol',
    '请输入角色名称': 'Por favor escribe el nombre del rol',
    '序号': 'Número Seiral',
    '所属组织': 'Organización Afiliad',
    '请输入': 'Por favor escribe',
    '输入用户名': 'Introduce nombre de usuario',
    '重置密码': 'Restablecer Contraseña',
    '姓名': 'Nombre',
    '确认密码': 'Confirmar Contraseña',
    '邮箱': 'Dirección De Correo Electrónico',
    '用户名中不能有空格': 'No debe haber espacios en el nombre de usuario',
    '请输入不少于4位的用户名': 'Por favor escribe un nombre de usuario de no menos de 4 dígitos',
    '该用户名已存在': 'Este nombre de usuario ya existe',
    '请输入姓名': 'Por favor, introduce el nombre',
    '请确认密码': 'Confirmar contraseña',
    '两次填写的密码不一致': 'Las contraseñas introducidas dos veces son inconsistentes',
    '请选择角色': 'Por favor, seleccione un rol',
    '请输入正确的邮箱地址': 'Introduzca una dirección de correo electrónico correcta',
    '创建时间': 'Hora De Creación',
    '最近修改时间': 'Hora De Última Modificación',
    '最近登录时间': 'Última Hora De Inicio De Sesión',
    '识别码': 'Número De Identificación',
    '经销商编号': 'Número De Concesionario',
    '型号': 'Modelo',
    '修改时间': 'Tiempo De Modificación',
    '备注': 'Observaciones',
    '批量添加': 'Importación Por Lotes',
    '导出': 'Exportar',
    '退出登录': 'Desconectar',
    '流水号': 'Número De Serie',
    '流水号/注册编号': 'Número De Serie/Registro',
    '请输入流水号/注册编号': 'Por favor, ingrese el número de serie/registro',
    '绑定密码': 'Vincular Contraseña',
    'TG密码': 'Password For【Setup】',
    '探棒设置密码': 'Password For【Probe Setup】',
    '自定义期限密码': 'Password For 【Customised Duration】',
    '永久期限密码': 'Password For 【Permanent Key】',
    '1个月密码': 'Password For 【1 Mth Effective Key】',
    '2个月密码': 'Password For 【2 Mth Effective Key】',
    '3个月密码': 'Password For 【3 Mth Effective Key】',
    '液位仪密码': 'Password For【Liquid Level Meter】',
    '请输入流水号': 'Introduzca el número de serie',
    '计算失败': 'Error de cálculo',
    '登录失败': 'Error al iniciar sesión',
    '请先选择类型': 'Seleccione primero el tipo',
    '取消space': 'Cancelar',
    '确定space': 'Confirmar',
    '将文件拖到此处，或': 'Arrastra el archivo aquí，o',
    '点击上传': ' haz clic para cargar',
    '只能上传xlsx/xls文件，且不超过500kb': 'Solo se pueden subir archivos xlsx/xls，y no pueden superar los 500kb',
    '模板': 'Plantilla',
    '保存': 'Guardar',
    '请输入识别码': 'Por favor escribe el número de identificación ',
    '识别码已存在': 'El número de identificación ya existe',
    '请选择型号': 'Por favor, seleccione un modelo',
    '请选择类型': 'Por favor, seleccione un tipo',
    '确认作废此数据?': 'Confirmar que estos datos no son válidos?',
    '提示': 'Notification',
    '确定': 'Confirmar',
    '作废成功': 'Invalidado con éxito',
    '作废失败': 'Error al invalidar',
    '当前限制选择 1 个文件': 'El límite actual es seleccionar un archivo',
    '请选择文件': 'Por favor, seleccione el archivo',
    '批量添加成功': 'Se ha añadido correctamente el lote',
    '批量添加失败': 'Error en la adición por lotes',
    '设备信息批量导入模板': 'Plantilla de importación de lotes de información del dispositivo',
    '设备信息': 'Dispositivo',
    '关联设备url': 'Url Del Dispositivo Asociado',
    '编号': 'Número',
    '国家或地区': 'País O Región',
    '联系人': 'Contactos',
    '电话': 'Teléfono',
    '复制': 'Copia',
    '关闭': 'Cerrar',
    '请输入名称': 'Introduzca el nombre',
    '名称已存在': 'El nombre ya existe',
    '请输入国家或地区': 'Introduzca el país o la región',
    '获取url失败': 'No se pudo obtener la url',
    '复制成功': 'Repilación exitosa',
    '经销商信息': 'Distribuidor',
    '经销商': 'Concesionario',
    '设备识别码': 'Número De Identificación Del Dispositivo',
    '审核': 'Auditoría',
    '审核结果': 'Resultados De Auditoría',
    '审核意见': 'Opiniones De Auditoría',
    '审核备注': 'Notas De Auditoría',
    '请选择经销商': 'Seleccione el concesionario',
    '请选择审核结果': 'Por favor, seleccione los resultados de la auditoría',
    '请输入审核意见': 'Por favor escribe las opiniones de auditoría',
    '同意': 'De Acuerdo',
    '不同意': 'En Desacuerdo',
    '审核成功': 'Auditado con éxito',
    '审核失败': 'Auditoría fallida',
    '有效': 'Efectivo',
    '失效': 'Eficacia Perdida',
    '经销商设备关联': 'Asociación de dispositivos distribuidores',
    '请输入设备识别码': 'Introduzca el número de identificación del dispositivo',
    '当前账号未绑定经销商，请联系管理员绑定': 'La cuenta corriente no está vinculada al distribuidor, póngase en contacto con el administrador para vincularla',
    '设备关联': 'De Dispositivos',
    '账号': 'Cuenta',
    '请选择账号': 'Por favor, seleccione la cuenta',
    '经销商账号关联': 'Distribuidor-cuenta',
    '参数键': 'Clave De Parámetro',
    '级参数': 'Parámetro De Nivel',
    '参数值': 'Valor Del Parámetro',
    '请输入参数键': 'Por favor escribe la clave del parámetro',
    '参数键已存在': 'La clave del parámetro ya existe',
    '所有语言参数值 都不能为空': 'Todos los valores de los parámetros de idioma no pueden estar vacíos',
    '经销商名称': 'Nombre Del Distribuido',
    '算号记录': 'Registros De Cálculo',
    '操作人员': 'Operador',
    '序号不能为空': 'El número de serie no puede estar vacío',
    '序号必须为正数': 'El número de serie debe ser positivo',
    '添加角色': 'Agregar Rol',
    '编辑角色': 'Editar Rol',
    '该角色将被删除, 是否继续?': 'El rol será borrado, ¿si continuar?',
    '添加用户': 'Agregar Usuario',
    '查询失败': 'Query Failed',
    '编辑用户': 'Editar Usuario',
    '此操作将重置': 'Esta operación restablecerá ',
    '用户密码为': ' la contraseña del usuario a ',
    ', 是否继续?': ', si continuar?',
    '重置成功': 'Reiniciar con éxito',
    '重置失败': 'Error de reinicio',
    '已取消重置': 'Se ha cancelado el restablecimiento',
    '数据加载中': 'Carga de datos...',
    '上滑查看更多': 'Desliza hacia arriba para ver más',
    '没有更多了': 'No hay más',
    '暂无数据': 'No hay datos en este momento',
    '无权限': ' Sin Permiso',
    '未登录': 'No conectado',
    '服务器未启动/响应错误': 'El servidor no se inicia/error de respuesta',
    '菜单查询': 'Consulta De Menú',
    '设置列': 'Establecer La Columna',
    '地址错误，请检查': 'La dirección es incorrecta, por favor, compruébelo',
    '澳科设备认证平台': 'Plataforma de certificación de dispositivos OKet',
    '欢迎您使用澳科设备绑定功能': 'Bienvenido a la función de vinculación de dispositivos de OKet',
    '绑定': 'Vinculación',
    '获取经销商信息失败': 'Error al obtener información del distribuidor',
    '未获取到经销商信息，请刷新页面': 'Si no obtiene la información del concesionario, actualice la página',
    '绑定成功': 'Vinculación correcta',
    '绑定失败': 'Fallo al enlazar',
    '版权所有': 'Todos los derechos reservados',
    '青岛澳科仪器有限责任公司': 'Qingdao OKet Instrument Co., Ltd.',
    '关闭其它': 'Cerca De Los Demás',
    '关闭所有': 'Cerrar Todo',
    '对应设备已存在': 'El dispositivo correspondiente ya existe',
    '文件': 'Archivo',
    '下载': 'Descargar',
    '液位仪安装验收单': 'OKet Debugging Inspection Confirmation Form--Automatic tank gauge',
    '测漏安装验收单': 'OKet Debugging Inspection Confirmation Form--Leak detection system',
    '安装工具清单': 'OKet Installation Tool List',
    '维护': 'OKet Maintenance Manual',
    '操作维护指南': 'OKet Operation and daily maintenance',
    '加油站': 'Estación',
    '请输入加油站': 'Por favor, ingrese la estación',
    '请先选择经销商': 'Seleccione el distribuidor primero',
    '员工': 'Empleado',
    '可计算密码类型': 'Tipos De Contraseña',
    '请选择员工': 'Por favor seleccione el empleado',
    '该员工已添加': 'El empleado ha sido agregado',
    '请选择设备识别码': 'Seleccione el número de identificación del dispositivo',
    '请选择可计算密码类型': 'Por favor seleccione los tipos de contraseña',
    '该经销商未关联用户': 'Este distribuidor no tiene usuarios asociados',
    '客服销售人员': 'Vendedor de servicio al cliente',
    '管理员': 'Administrador',
    '无此密码类型': 'No hay tal tipo de contraseña',
    bullshit_info: 'Por favor, comprueba si la URL que has introducido es correcta. Haz clic en el botón de abajo para volver a la página de inicio o enviar un informe de error',
    return_home: 'Volver al centro personal',
    cant_in: 'El webmaster dice que no puedes ingresar a esta página...',
    advice: 'Para ofrecerte una mejor experiencia de usuario, te recomendamos encarecidamente que utilices el modo de velocidad o el navegador Chrome',
    // 后端
    '暂未登录或token已经过期': 'No ha iniciado sesión o el token ha caducado'
  },
  fun: {
    '公告': 'Anuncio',
    '公告详情': 'Detalles Del Anuncio',
    '在线考试': 'Examen En Linea',
    '考试记录': 'Registros De Examen',
    '证书信息': 'Información Certificada',
    '证书统计': 'Estadísticas Certificados',
    '公告管理': 'Gestión De Anuncios',
    '培训视频': 'vídeo De Entrenamiento',
    '培训视频管理': 'Gestión De Vídeos De Formación',
    '视频标签管理': 'Gestión De Etiquetas De Vídeo',
    '题库管理': 'Gestión Del Banco De Preguntas',
    '单选题库管理': 'Radio Banco De Preguntas',
    '多选题库管理': 'Opción Multiple Banco De Preguntas',
    '判断题库管理': 'Juez Banco De Preguntas',
    '用户权限': 'Derechos de los usuarios',
    '用户管理': 'Gestión de usuarios',
    '组织管理': 'Gestión de la organización',
    '角色管理': 'Gestión de roles',
    '功能管理': 'Gestión de funciones',
    '设备信息': 'Dispositivo',
    '经销商信息': 'Distribuidor',
    '经销商-设备关联': 'Distribuidor-dispositivo',
    '经销商-账号关联': 'Asociación de cuentas de distribuidor',
    '系统字典': 'Diccionario del sistema',
    '算号记录': 'Registros de cálculo',
    '设备关联': 'De dispositivos',
    '密码计算': 'Calculadora de contraseñas',
    '查询设备全部': 'Consultar todos los dispositivos',
    'App': 'App',
    'getInfo': 'getInfo',
    '分页查询设备': 'Dispositivo de consulta de paginación',
    '添加设备信息': 'Agregar información del dispositivo',
    '更新设备信息': 'Actualizar información del dispositivo',
    '设备作废': 'equipo obsoleto',
    '设备识别码判重': 'Juicio del código de identificación del dispositivo',
    '分页查询经销商': 'Buscar distribuidores por página',
    '查询设备经销商全部': 'Consultar todos los distribuidores de equipos',
    '添加经销商信息': 'Agregar información del distribuidor',
    '更新经销商信息': 'Actualizar información del distribuidor',
    '经销商信息作废': 'La información del distribuidor no es válida',
    '经销商名称、编号判重': 'Nombre del distribuidor y número de serie',
    '获取当前用户的经销商': 'Obtener el distribuidor del usuario actual',
    '分页查询经销商设备关联': 'Consulta de asociación de equipos de distribuidores por página',
    '查询经销商设备关联全部': 'Consulta de asociación de equipos de distribuidores todos',
    '添加经销商设备关联信息': 'Agregar información de asociación de equipos de distribuidores',
    '更新经销商设备关联信息': 'Actualizar la información de la asociación de distribuidores de equipos',
    '经销商设备关联作废': 'Anulación de la asociación de concesionarios',
    '经销商-设备关联查询设备全部': 'Distribuidores - Equipos Búsqueda asociada Equipos Todos',
    '经销商-设备关联查询设备经销商全部': 'Distribuidores - Equipos Búsqueda asociada Distribuidores de equipos Todos',
    '经销商-设备关联分页查询经销商设备关联': 'Asociaciones de distribuidores de equipos paginación de las asociaciones de distribuidores de equipos',
    '经销商-设备关联查询经销商设备关联全部': 'Dealer-Equipment Connection Búsqueda Dealer Equipment Connection Todos',
    '经销商-设备关联添加经销商设备关联信息': 'Concesionario - Asociaciones de equiposAñadir información sobre asociaciones de concesionarios de equipos',
    '经销商-设备关联更新经销商设备关联信息': 'Dealer-Equipment ConnectionActualizar la información de Dealer Equipment Connection',
    '经销商-设备关联经销商设备关联作废': 'Distribuidores - Asociaciones de equiposAsociaciones de distribuidores de equipos anuladas',
    '经销商设备关联审核': 'Auditoría de la asociación de distribuidores de equipos',
    '分页查询经销商账号关联': 'Paginación búsqueda asociación cuenta concesionario',
    '查询经销商账号关联全部': 'Comprobar la asociación de la cuenta del distribuidor todos',
    '添加经销商账号关联信息': 'Agregar información de asociación a la cuenta del concesionario',
    '更新经销商账号关联信息': 'Actualizar la información de asociación de la cuenta del concesionario',
    '经销商账号关联作废': 'Invalidación de la asociación de cuentas de distribuidores',
    '经销商-账号关联获取所有得用户列表': 'Asociación concesionario-cuenta para una lista de todos los usuarios',
    '经销商-账号关联查询设备经销商全部': 'Concesionario-Cuenta asociada Búsqueda Concesionarios de equipos Todos',
    '右上角添加/修改用户': 'Agregar/modificar usuarios en la esquina superior derecha',
    '用户头像-上传本地': 'Avatar de usuario - subir local',
    '用户密码修改': 'Cambio de contraseña de usuario',
    '分页查询组织': 'Organización de la búsqueda por páginas',
    '添加组织': 'Agregar organización',
    '编辑组织': 'Organización editorial',
    '校验组织是否存在': 'Verificar la existencia de la organización',
    '查询角色列表': 'Buscar en la lista de funciones',
    '删除角色': 'Eliminar función',
    '角色查询所有得权限': 'Búsqueda de funciones Todos los permisos',
    '添加/编辑角色': 'Agregar/editar funciones',
    '组织根节点列表': 'Lista de nodos raíz organizativos',
    '查询所有得权限': 'Comprobar todos los permisos',
    '获取所有的菜单': 'Obtener todos los menús',
    '添加/编辑权限': 'Agregar/editar permisos',
    '获取所有得用户列表': 'Obtener una lista de todos los usuarios',
    '添加/修改用户': 'Agregar/modificar usuarios',
    '用户密码重置': 'Restablecer contraseña de usuario',
    '用户是否存在': '¿Existe el usuario?',
    '获取算号': 'Obtener el recuento',
    '查询全部算号': 'Compruebe todos los números',
    '分页查询算号': 'Búsqueda por paginación Numeración',
    '获取关联设备的url': 'Obtener la url del dispositivo asociado',
    '分页查询系统字典项(树形)': 'Elementos del diccionario del sistema de consulta por paginación (árbol)',
    '查询所有系统字典项-列表': 'Consultar todos los elementos del diccionario del sistema - lista',
    '查询系统字典类型': 'Tipo de diccionario del sistema de consulta',
    '添加系统字典': 'Agregar un diccionario del sistema',
    '编辑系统字典': 'Editar el diccionario del sistema',
    '查询下一级系统字典项': 'Consultar el siguiente nivel de entradas del diccionario del sistema',
    '校验参数键是否重复': 'Comprobación de claves de parámetros duplicadas',
    '设备查询下一级系统字典项': 'Consulta del dispositivo elemento del diccionario del sistema de nivel siguiente',
    '批量导入设备信息': 'Información del dispositivo de importación por lotes',
    '技术文档资料库': 'Biblioteca De Documentación Técnica',
    '技术文档资料库界面': 'Interfaz de la Biblioteca de Documentos Técnicos',
    '更新设备信息admin': 'Actualizar administrador de información del dispositivo',
    '更新设备信息noadmin': 'Actualizar información del dispositivo noAdmin',
    '员工权限': 'Permisos del empleado',
    '查询当前用户组织下可查看角色': 'Consultar los roles disponibles en la organización del usuario actual',
    '查询算号记录算密码类型': 'Tipo de contraseña de cálculo de registro de cálculo de número de consulta',
    '查询密码计算算密码类型': 'Consulta cálculo de contraseña calcular tipo de contraseña',
    '查询当前用户角色': 'Consultar el rol de usuario actual',
    '查询员工权限算密码类型': 'Consultar la autoridad del empleado y calcular el tipo de contraseña',
    '分页查询员工权限': 'Consultar permisos de empleados por página',
    '查询员工权限全部': 'Consultar todos los permisos de los empleados',
    '添加员工权限': 'Agregar permisos de empleados',
    '编辑员工权限': 'Editar permisos de empleados',
    '校验经销商员工关系是否唯一': 'Verifique que la relación del empleado del distribuidor sea única',
    '员工权限作废': 'Autoridad del empleado nula',
    '查询指定用户组织下的用户': 'Consultar a los usuarios de la organización de usuarios especificada',
    '员工权限查询经销商设备关联全部': 'Consulta de permiso de empleado Asociación de equipos de distribuidores todos',
    '员工权限获取所有得用户列表': 'Permiso de empleado para obtener todas las listas de usuarios',
    '员工权限获取当前用户的经销商': 'Permisos de empleados Obtener revendedores de usuarios actuales',
    '员工权限查询设备经销商全部': 'Todos los distribuidores de equipos de consulta de permisos de empleados',
    '员工权限查询经销商账号关联全部': 'Consulta de permisos de empleados Cuenta de distribuidor asociada con todos',
    '用户管理查询当前用户角色': 'Consulta de administración de usuarios rol de usuario actual',
    '获取全部国家和地区': 'Obtener todos los países y regiones',
    '公告分页': 'Página Anuncios',
    '阅读公告': 'Leer Anuncio',
    '公告（详情）': 'Anuncio (detalles)',
    '公告分页（管理）': 'Pestaña Anuncios (gestión)',
    '添加公告': 'Agregar Anuncio',
    '编辑公告': 'Anuncio Editorial',
    '删除公告': 'Borrar Aviso',
    '新增试卷（考试）': 'Nuevo Papel Prueba (examen)',
    '试卷内容': 'Contenido Papel Prueba',
    '提交试卷': 'Enviar Papel Prueba',
    '试卷分页（考试记录）': 'Paginación de documentos de prueba (registros de examen)',
    '用户列表': 'Lista Usuarios',
    '新增试卷': 'Nuevo Papel Prueba',
    '证书分页': 'Paginación Certificados',
    '用户列表（证书）': 'Lista Usuarios (certificado)',
    '培训视频分页': 'Paginación Vídeos Formación',
    '培训视频标签分页（视频）': 'Paginación La Pestaña Videos Capacitación (videos)',
    '培训视频分页（管理）': 'Paginación Vídeos Formación (gestión)',
    '添加培训视频': 'Agregar Video Entrenamiento',
    '编辑培训视频': 'Editar Video Capacitación',
    '删除培训视频': 'Eliminar Video Entrenamiento',
    '培训视频标签分页（管理）': 'Paginación La Pestaña Vídeos Formación (Administración)',
    '培训视频标签分页': 'Paginación La Pestaña Vídeos Formación',
    '添加培训视频标签': 'Agregar Etiqueta Video Entrenamiento',
    '编辑培训视频标签': 'Editar Etiquetas Video Capacitación',
    '删除培训视频标签': 'Eliminar Etiquetas Videos Entrenamiento',
    '题目列表分页(单选)': 'Paginación La Lista Temas (opción única)',
    '新增题目（单选）': 'Agregar Un Tema (opción única)',
    '删除题目（单选）': 'Eliminar Tema (opción única)',
    '题目列表分页（多选）': 'Paginación La Lista Temas (opción múltiple)',
    '新增题目（多选）': 'Añadir Un Tema (opción múltiple)',
    '删除题目（多选）': 'Eliminar Tema (opción múltiple)',
    '题目列表分页（判断）': 'Paginación La Lista Temas (juicio)',
    '新增题目（判断）': 'Agregar Nuevo Tema (juicio)',
    '删除题目（判断）': 'Eliminar Tema (sentencia)',
    '考试培训': 'Entrenamiento Examen',
    '系统管理': 'Gestión Sistema',
    '证书下载': 'Descarga Certificado',
    '证书下载（考试记录）': 'Descarga Certificado(registros examen)',
    '证书分页（统计）': 'Paginación Certificados (Estadísticas)',
    '用户列表（统计）': 'Lista Usuarios (Estadísticas)',
    '证书下载（统计）': 'Descarga Certificado (Estadísticas)'
  },
  file: {
    'ATG系列文档': 'ATG Series Documents',

    'ATG操作手册': 'ATG Operation Manual',
    '1-1-3-1-1': "1-1-3-1-1 PD-350+ Networking Tank-eye Operator's Manual V1.5-20250528",
    '1-1-3-1-2': '1-1-3-1-2 PD-350 & PD-350+ Series Console Operator’s Manual 20250520',
    '1-1-3-1-4': '1-1-3-1-4 MC-6 Explosion proof Console Operator’s Manual V2.0',
    '1-1-3-1-5': '1-1-3-1-5 OKet Console Quick Start Guide (20250519)',
    '1-1-3-1-6': '1-1-3-1-6 OKet Guide de Démarrage 20250522',
    '1-1-3-1-7': '1-1-3-1-7 OKet Guía de Inicio Rápido_',

    'ATG改造和安装指南': 'ATG Retrofit And Installation Guide',
    '1-1-4-2-1': '1-1-4-2-1 Automatic Tank Gauge for DEF tanks Installation Guide',
    '1-1-4-2-2': '1-1-4-2-2 Automatic Tank Gauge for LPG tanks Installation Guide',
    '1-1-4-2-3': '1-1-4-2-3 Wired ATG Installation Guide-20251125',
    '1-1-4-2-4': '1-1-4-2-4 Automatic Tank Gauge Installation Guide',
    '1-1-4-2-6': '1-1-4-2-6 Guidance for changing the ATGs grounding method to the single tank shielding layer grounding method',
    '1-1-4-2-7': '1-1-4-2-7 Automatic Tank Gauges Probe Installation Guide for Lubricant',
    '1-1-4-2-8': '1-1-4-2-8 Wireless ATG Installation Guide-20250930',
    '1-1-4-2-9': '1-1-4-2-9 The operation of installing the button cell',
    '1-1-4-2-10': '1-1-4-2-10 Differential pressure level gauge installation and operation guide V1.1-20240829 EN',
    '1-1-4-3-1-1': '1-1-4-3-1-1 Probe length calculation drawing',
    '1-1-4-3-1-2': '1-1-4-3-1-2 Probe length table',
    '1-1-4-3-2-2': '1-1-4-3-2-2 Wired ATG Field Construction and Retrofit Guide',
    '1-1-4-3-2-3': '1-1-4-3-2-3 Wireless ATG Field Construction and Retrofit Guide V1.0 20250415',
    'B——3': "B——3'' B-type riser cover(NPT pipe thread)-Model",
    'N——3': "N——3'' N-type riser cover(G pipe thread)-Model",
    'riser': 'riser cap-2024.11.06',

    'ATG维护指南': 'ATG Maintenance And Troubleshooting',
    '1-1-7-6-1': '1-1-7-6-1 ATG Maintenance Guide',
    '1-1-7-6-2': '1-1-7-6-2 ATG Troubleshooting Guide',
    '1-1-3-5-2': '1-1-3-5-2 ATG Daily Operations and Maintenance  (pdf)',
    '1-1-3-5-3': '1-1-3-5-3 Automatic Tank Gauges Usage Guidelines',
    '1-1-9-1-1': '1-1-9-1-1 OKet PD-350 Series Consoles Troubleshooting Manual（20230807）',

    'LD系列文档': 'LDS Series Documents',

    'LD操作手册：请参考《ATG操作手册》LD改装及安装指南': 'LDS Operation Manual：Please refer to 《ATG Operation Manual》 LDS Retrofit and Installation Guide',

    'LD改造和安装指南': 'LDS Retrofit And Installation Guide',
    '1-2-4-1-1': '1-2-4-1-1 Dispenser Pan Leak Detection Sensor Installation Guide DPLS-1 and DPLS-2C',
    '1-2-4-1-2': '1-2-4-1-2 Double-wall tank gap leak Detection sensor Installation Guide SFLS-2F',
    '1-2-4-1-3': '1-2-4-1-3 Double Wall Pipeline Leak Detection Sensor Installation Guide DLLS-2DA and DLLS-2C ',
    '1-2-4-1-4': '1-2-4-1-4 FRP-Steel Double-wall Tank Leak Detection Sensor Installation Guide SFLS-2DA SFLS-2C ',
    '1-2-4-1-5': '1-2-4-1-5 FRP Double-wall Tank Leak  Detection Sensor Installation Guide HLS-1D',
    '1-2-4-1-6': '1-2-4-1-6 Manhole Well Leak Detection Sensor Installation Guide--CSLS-1',
    '1-2-4-1-7': '1-2-4-1-7 Tank Containment Sump Leak Detection Sensor Installation Guide---FSLS-1',
    '1-2-4-1-9': '1-2-4-1-9 Tank vacuum leak sensor installation guide---vtls-1',

    'LD维护指南': 'LDS Maintenance Guide',
    '1-2-7-1': '1-2-7-1 Leak Sensor Modification Address Operation Instructions',

    'HSSE要求': 'HSSE Requirements',
    'OKet HSSE管理体系要求V202306': 'OKet HSSE Management System Requirements V202306',

    '工具清单和收据模板': 'Tool List And Receipt Template',
    '1-1-4-4-1': '1-1-4-4-1 Installation Tool List for ATG and LDS',
    '1-1-4-4-2': '1-1-4-4-2 Automatic Tank Gauges Installation Acceptance Form ',
    '1-1-5-1-1': "1-1-5-1-1 OKet's ATG Order needs to be clear",
    '1-1-5-1-2': "1-1-5-1-2 OKet's ATG Order needs to be clear（wireless)",
    '1-1-5-2-1': '1-1-5-2-1 ATG 2 inches Packing List & Acceptance Form',
    '1-1-5-2-2': '1-1-5-2-2 ATG 3 inches Packing List & Acceptance Form',
    '1-1-5-2-3': '1-1-5-2-3 ATG(wireless) Packing List & Acceptance Form',
    '1-2-5-1-1': '1-2-5-1-1 CSLS-1 Packing List & Acceptance Form',
    '1-2-5-1-2': '1-2-5-1-2  Packing List & Acceptance Form',
    '1-2-5-1-3': '1-2-5-1-3  DPLS-1 Packing List & Acceptance Form',
    '1-2-5-1-4': '1-2-5-1-4  FSLS-1Packing List & Acceptance Form',
    '1-2-5-2': '1-2-5-2 Leak Detection Integrated Installation Acceptance Form '
  },
  exam: {
    '题目': 'Tema',
    '题目类别': 'Categoría De Tema',
    '题目答案': 'Pregunta Respuesta',
    '答案解析': 'Análisis De Respuesta',
    '暂无解析': 'Sin Resolución Todavía',
    '序号': 'Número De Serie',
    '题目内容': 'Contenido Del Tema',
    '题目配图': 'Imagen Del Tema',
    '暂无': 'No Todavía',
    '操作': 'Funcionar',
    '删除': 'Borrar',
    '选项A': 'Opción A',
    '选项B': 'Opción B',
    '选项C': 'Opción C',
    '选项D': 'Opción D',
    '选项E': 'Opción E',
    '选项F': 'Opción F',
    '选项G': 'Opción G',
    '添加题目': 'Añadir Tema',
    '编辑题目': 'Editar Tema',
    '确认添加': 'Confirmar Agregar',
    '确认编辑': 'Confirmar Edición',
    '选项A为必填项': 'Se requiere la opción A',
    '选项B为必填项': 'Se requiere la opción B',
    '选项C为必填项': 'Se requiere la opción C',
    '请选择题目类型': 'Seleccione un tipo de tema',
    '题目内容为必填项': 'El contenido del tema es obligatorio',
    '题目答案为必填项': 'La respuesta a la pregunta es obligatoria',
    'ATG安装': 'Instalación ATG',
    'LDS安装': 'Instalación SUD',
    '保存成功': 'Guardado Exitosamente',
    '保存失败': 'Error Al Guardar',
    '确定删除该题目吗': 'Está seguro de que desea eliminar esta pregunta',
    '删除成功': 'Eliminado Con Exito',
    '删除失败': 'No Se Pudo Eliminar',
    '正确': 'Correcto',
    '错误': 'Error',
    '组织员工': 'Organizar Personal',
    '员工': 'Personal',
    '证书类别': 'Tipo De Certificado',
    '证书下载': 'Descarga De Certificado',
    '员工列表查询失败': 'Consulta de lista de empleados fallida',
    '资质证书': 'Certificaciones',
    '证书有效期': 'Validez Del Certificado',
    '试卷类别': 'Papel Categoría',
    '考试结果': 'Resultado De La Prueba',
    '再次考试': 'Re Examinar',
    '合格': 'Calificado',
    '不合格': 'No Cualificado',
    '生成试卷失败': 'No se pudo generar el papel de prueba',
    '考试开始时间': 'Hora De Inicio Del Examen',
    '考试结束时间': 'Hora De Finalización Del Examen',
    '考试进行中': 'Examen En Curso',
    '技能类别': 'Categoría De Habilidad',
    '标签中文名称': 'Etiqueta Nombre Chino',
    '标签英文名称': 'Etiqueta Nombre En Inglés',
    '标签西班牙名称': 'Etiqueta Nombre En Español',
    '标签法语名称': 'Etiqueta Nombre Francés',
    '请选择技能类别': 'Seleccione una categoría de habilidad',
    '请输入标签中文名称': 'Ingrese el nombre chino de la etiqueta',
    '请输入标签英文名称': 'Ingrese el nombre en inglés de la etiqueta',
    '请输入标签西班牙名称': 'Por favor ingrese un nombre de etiqueta en español',
    '请输入标签法语名称': 'Por favor introduzca la etiqueta Nombre francés',
    '返回': 'Devolver',
    '公告标题': 'Título Del Anuncio',
    '公告内容': 'Contenido Del Anuncio',
    '公告标题(中文)': 'Título Del Anuncio(Chino)',
    '公告内容(中文)': 'Contenido Del Anuncio(Chino)',
    '公告标题(英文)': 'Título Del Anuncio(Inglés)',
    '公告内容(英文)': 'Contenido Del Anuncio(Inglés)',
    '公告标题(西班牙)': 'Título Del Anuncio(Español)',
    '公告内容(西班牙)': 'Contenido Del Anuncio(Español)',
    '公告标题(法语)': 'Título Del Anuncio(Francés)',
    '公告内容(法语)': 'Contenido Del Anuncio(Francés)',
    '请输入公告标题(中文)': 'Por favor ingrese el título del anuncio(Chino)',
    '请输入公告内容(中文)': 'Por favor ingrese el contenido del anuncio(Chino)',
    '请输入公告标题(英文)': 'Por favor ingrese el título del anuncio(Inglés)',
    '请输入公告内容(英文)': 'Por favor ingrese el contenido del anuncio(Inglés)',
    '请输入公告标题(西班牙)': 'Por favor ingrese el título del anuncio(Español)',
    '请输入公告内容(西班牙)': 'Por favor ingrese el contenido del anuncio(Español)',
    '请输入公告标题(法语)': 'Por favor ingrese el título del anuncio(Francés)',
    '请输入公告内容(法语)': 'Por favor ingrese el contenido del anuncio(Francés)',
    '发布时间': 'Tiempo De Liberación',
    '已读': 'Han Leído',
    '未读': 'No Leído',
    '记录阅读状态失败': 'Estado de lectura de registro fallido',
    'ATG安装技师考试': 'Examen de Técnico de Instalación ATG',
    'LDS安装技师考试': 'Examen de técnico de instalación SUD',
    '参加考试': 'Tomar El Examen',
    '退出': 'Abandonar',
    '答题卡': 'Hoja De Respuestas',
    '考试日期': 'Fecha Del Examen',
    '考试时长': 'Duración Del Examen',
    '分钟': 'Minutos',
    '单选题': 'Radio Banco',
    '分': 'Puntos',
    '多选题': 'Opción Multiple Banco',
    '判断题': 'Juez Banco',
    '无': 'Ninguno',
    '上一题': 'Pregunta Anterior',
    '下一题': 'Próxima Pregunta',
    '提交试卷': 'Entregar',
    '已完成': 'Terminado',
    '每题': 'Por Pregunta',
    '加载中': 'Cargando',
    '获取试卷详情失败': 'Error al obtener los detalles del papel de prueba',
    '交卷时间已到，系统将帮您自动交卷': 'Se acabó el tiempo de entrega del papel, el sistema automáticamente entregará el papel por usted',
    '交卷失败，数据库错误，请重新开始考试': 'Envío fallido, error de base de datos, reinicie el examen',
    '确定要提交试卷吗': 'Está seguro de que desea enviar el documento de prueba',
    '尚未完成所有题目，确定要提交试卷吗': 'No ha completado todas las preguntas, está seguro de que desea enviar el examen',
    '自动计算成绩中': 'Cálculo automático de calificaciones',
    '提交成功': 'Enviado Satisfactoriamente',
    '系统将自动提交试卷，请确认是否离开考试': 'El sistema enviará automáticamente el documento de prueba, confirme si desea abandonar la prueba',
    '退出考试，系统已自动提交试卷': 'Salga de la prueba, el sistema ha enviado automáticamente el documento de prueba',
    '可到记录页面查看成绩': 'Ir a la página de registro para ver los resultados',
    '试卷详情': 'Detalles Del Examen',
    '试卷类型': 'Tipo De Papel',
    '全部题数': 'Todas Las Preguntas',
    '道': 'Camino',
    '试卷总分': 'Puntaje Total',
    '及格标准': 'Pasar El Estándar',
    '题型介绍': 'Introducción Al Tipo De Pregunta',
    '考试说明': 'Descripción Del Examen',
    '开始考试': 'Empezar Examen',
    '确定开始考试吗': 'Está seguro de que desea iniciar la prueba',
    '请开始作答': 'Por favor empieza a responder',
    '视频类别': 'Categoría De Vídeo',
    '视频名称': 'Nombre Del Video',
    '视频封面': 'Portada De Vídeo',
    '视频文件': 'Archivo De Vídeo',
    '视频名称(英文)': 'Nombre Del Video(Inglés)',
    '视频封面(英文)': 'Portada De Vídeo(Inglés)',
    '视频文件(英文)': 'Archivo De Vídeo(Inglés)',
    '视频名称(中文)': 'Nombre Del Video(Chino)',
    '视频封面(中文)': 'Portada De Vídeo(Chino)',
    '视频文件(中文)': 'Archivo De Vídeo(Chino)',
    '视频名称(西班牙)': 'Nombre Del Video(Español)',
    '视频封面(西班牙)': 'Portada De Vídeo(Español)',
    '视频文件(西班牙)': 'Archivo De Vídeo(Español)',
    '视频名称(法语)': 'Nombre Del Video(Francés)',
    '视频封面(法语)': 'Portada De Vídeo(Francés)',
    '视频文件(法语)': 'Archivo De Vídeo(Francés)',
    '请输入视频名称(英文)': 'Introduce un nombre de vídeo(Inglés)',
    '请选择视频类别': 'Seleccione una categoría de video',
    '全部': 'Todo',
    '查询视频标签数据失败': 'Error al consultar los datos de la etiqueta de video',
    '图片大小不能超过2MB': 'El tamaño de la imagen no puede exceder los 2 MB',
    '当前限制选择 1 个文件': 'Límite actual para seleccionar 1 archivo',
    '点击下载': 'Haga Clic Para Descargar',
    '题型单选题': 'Radio Banco ',
    '题型多选题': 'Opción Multiple Banco ',
    '题型判断题': 'Juez Banco ',
    '题型道': ' Camino',
    '题型每题': ' Por Pregunta ',
    '题型分': ' Puntos',
    '上传文件只能是mp4格式': 'Los archivos subidos solo pueden estar en formato .mp4',
    '请上传视频封面(英文)': 'Sube la portada del video(Inglés)',
    '请上传视频文件(英文)': 'Sube un archivo de video(Inglés)',
    '上传头像图片只能是JPG/JPEG/PNG格式': 'La imagen de perfil cargada solo puede estar en formato JPG/JPEG/PNG',
    '下载失败': 'Descarga fracasó'
  }
}



// WEBPACK FOOTER //
// ./src/lang/es.js